module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Visible-aa357871bde151cf3eb1cedbef11fe81.svg";